<template>
  <span>
    <van-button v-if="isChanged">已交换名片</van-button>
    <van-button v-else @click="changeCard">交换名片</van-button>
    <van-dialog
      v-model="showChangCard"
      title="您已关注TA"
      show-cancel-button
      close-on-click-overlay
      :before-close="handleCloseCard"
    >
      <div class="change-card-msg">为了更好的提供服务，是否与TA交换名片</div>
      <div class="change-card-msg">
        <van-checkbox v-model="notShowChangeCardDialog">不再提示</van-checkbox>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showNoticeComplete"
      title="提示"
      close-on-click-overlay
      :show-confirm-button="false"
      :before-close="handleCloseComplete"
      >
      <div class="change-card-msg">需完善名片的必填项后才可与TA交换名片</div>
      <div class="change-card-btn"><van-button type="primary" @click="goPage">立即完善名片信息</van-button></div>
    </van-dialog>
  </span>
</template>
<script>
import { Cms } from "@/api";
export default {
  props: {
    FollowedUserId: Number,
    FollowStatus: Number
  },
  watch: {
    FollowStatus(val) {
      this.isChanged = (val & 4) === 4
      this.isFollow = this.FollowStatus !== 8
    }
  },
  data() {
    return {
      isFollow: this.FollowStatus!== 8,
      showChangCard: false,
      notShowChangeCardDialog: false,
      showNoticeComplete: false,
      ShowChangeCardDialogKey: "notShowChangeCardDialog",
      userId: this.$mdUtils.getUserInfo("Id"),
      isChanged: (this.FollowStatus & 4) === 4
    };
  },
 
  methods: {
    changeCard() {
      this.notShowChangeCardDialog = localStorage.getItem(
        this.ShowChangeCardDialogKey
      );
      if (this.FollowStatus === 8) {
        this.$api(Cms.FollowToggleFollow, {
          UserId: this.userId,
          FollowedUserId: this.FollowedUserId
        }).then(() => {
          this.$emit('changeSuccess', true)
        });
      }

      if (!this.notShowChangeCardDialog) {
        this.showChangCard = true;
      } else {
        this.changeCardApi()
      }
    },
    handleCloseCard(action, done) {
      this.showChangCard = false;
      if (action !== "cancel") {
        this.changeCardApi()
      }
      if (this.notShowChangeCardDialog) {
        localStorage.setItem(this.ShowChangeCardDialogKey, true);
      }
      done();
    },
    changeCardApi() {
      this.$api(
        Cms.FollowChangeCard,
        {
          UserId: this.userId,
          FollowedUserId: this.FollowedUserId
        },
        false,
        false
      ).then(() => {
        this.$tips.toast('交换成功')
        this.$emit('changeSuccess', true)
        this.isChanged = true
      })
      .catch(err => {
        if (err.ErrorCode == "ChangeCard_Imperfect") {
          this.showNoticeComplete = true;
        }
      });
    },
    goPage() {
      this.$router.push({ name: "mycard" });
    },
    handleCloseComplete() {
      this.showNoticeComplete = false
    }
  }
};
</script>
<style lang="scss">
.change-card-btn {
  .van-button {
    width: 100%!important;
  }
}
</style>

<style lang='scss' scoped>
.change-card-msg {
  padding: 10px 26px;
  font-size: $font-size-normal;
}
.change-card-btn {
  padding: 20px;
}
</style>